import { render, staticRenderFns } from "./ContactFiles.vue?vue&type=template&id=1097655e&scoped=true&"
import script from "./ContactFiles.vue?vue&type=script&lang=js&"
export * from "./ContactFiles.vue?vue&type=script&lang=js&"
import style0 from "./ContactFiles.vue?vue&type=style&index=0&id=1097655e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1097655e",
  null
  
)

export default component.exports